import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { PlatformSelectPropsType } from "./interface";

const useStyles = makeStyles({
    optionSelect: {
      marginBottom: "20px",
    },
  });

const PlatformSelect = (props: PlatformSelectPropsType) => {
  const [platform, setPlatform] = useState(props.platforms[0]);
  const classes = useStyles();

  useEffect(() => {
    props.updatePlatformhandler(platform)
  }, [platform, props])

  const handleChange = async (event: any) => {
    setPlatform(event.target.value)
  };

  return (
    <FormControl fullWidth className={classes.optionSelect}>
      <InputLabel id="demo-simple-select-label">Platform</InputLabel>
      <Select defaultValue={props.platforms[0]} onChange={handleChange}>
        <MenuItem value={props.platforms[0]}>{props.platforms[0]}</MenuItem>
        <MenuItem value={props.platforms[1]}>{props.platforms[1]}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default PlatformSelect;
